import BaseService from '@/ecm/common/BaseService.js';
import Utils from '@/ecm/common/Utils.js';

class ContentTypeService {
  baseUrl = 'content-type';

  getGrid = () => Utils.grid.getParameters(`${this.baseUrl}/get-grid`);
  getList = (onlyLastVersion, checkObjectCreation) => BaseService.get({ url: `${this.baseUrl}/list/${onlyLastVersion || true}/${checkObjectCreation || false}` });
  getElements = (id) => BaseService.get({ url: `${this.baseUrl}/list-field-elements/${id}` });
  getVersions = (id) => BaseService.get({ url: `${this.baseUrl}/versions/${id}` });
  delete = (id) => BaseService.delete({ url: `${this.baseUrl}/${id}` });
  keepActualVersion = (contentTypeData) => BaseService.post({ url: `${this.baseUrl}/keep-actual-version`, data: contentTypeData });
  getSharedFields = (contentTypeId, fieldCode) => BaseService.get({ url: `${this.baseUrl}/shared-fields/${contentTypeId}/${fieldCode}` });
  get = (id) => BaseService.get({ url: `${this.baseUrl}/get-content-type-by-id/${id}` });
  save = (contentTypeData) => BaseService.post({ url: `${this.baseUrl}/save`, data: contentTypeData });

  getFields = (contentTypeIDs) => BaseService.get({ url: `${this.baseUrl}/get-fields/${contentTypeIDs}` });
  getListElements = (defFieldCode, parameters) => BaseService.post({ url: `${this.baseUrl}/get-list-elements/${defFieldCode.trimEnd()}`, data: parameters });
  getListElementsByDefField = (defFieldId, filterQuery) => BaseService.post({ url: `${this.baseUrl}/get-list-elements-by-deffield/${defFieldId}`, data: filterQuery });
  searchFields = (searchText) => BaseService.get({ url: `${this.baseUrl}/search-fields?searchText=${searchText}` });
  searchFieldsByCode = (searchText) => BaseService.get({ url: `${this.baseUrl}/search-fields-by-code?searchText=${searchText}` });
  testDynamicList = (test) => BaseService.post({ url: `${this.baseUrl}/test-dynamic-list`, data: test });

  // Export Configuration
  getEncodingList = () => BaseService.get({ url: `${this.baseUrl}/encoding-list` });
  getExportConfig = (id) => BaseService.get({ url: `${this.baseUrl}/export-config/${id}` });
  saveExportConfig = (id, exportConfig) => BaseService.post({ url: `${this.baseUrl}/export-config/${id}`, data: exportConfig });

  // Rights
  getRights = (id) => BaseService.get({ url: `${this.baseUrl}/rights/${id}` });
  saveRights = (id, rights) => BaseService.post({ url: `${this.baseUrl}/save-rights/${id}`, data: rights });
  getFieldsRights = (id) => BaseService.get({ url: `${this.baseUrl}/fields-rights/${id}` });
  saveFieldsRights = (id, rights) => BaseService.post({ url: `${this.baseUrl}/save-fields-rights/${id}`, data: rights });

  // Auto import config
  getAutoImportConfigs = (id) => BaseService.get({ url: `${this.baseUrl}/auto-import-configs/${id}` });
  saveAutoImportConfigs = (autoImportConfigs) => BaseService.post({ url: '/content-type-auto-import-config', data: autoImportConfigs });
  updateAutoImportConfigs = (autoImportConfigs) => BaseService.put({ url: '/content-type-auto-import-config', data: autoImportConfigs });
  deleteAutoImportConfigs = (id) => BaseService.delete({ url: `/content-type-auto-import-config/${id}` });
  getContentTypeForAutoImport = (id) => BaseService.get({ url: `/content-type-auto-import-config/${id}` });
  getAutoImportConfigsFailed = () => BaseService.get({ url: `${this.baseUrl}/get-auto-import-configs-failed` });
  reactivateAutoImportConfigFailed = (id) => BaseService.post({ url: `${this.baseUrl}/reactivate-auto-import-config/${id}` });
  getAvailableProviders = () => BaseService.get({ url: '/content-type-auto-import-config/providers' });

  // Alerts
  getAlerts = (id) => BaseService.get({ url: `${this.baseUrl}/alerts/${id}` });
  saveAlerts = (id, rights) => BaseService.post({ url: `${this.baseUrl}/alerts/${id}`, data: rights });

  // Export/Import
  export = (ids) => Utils.file.attachment.download(`${this.baseUrl}/export/${ids}`);
  import = (ctypes) => BaseService.post({ url: `${this.baseUrl}/import`, data: ctypes });

  //Document Intelligence
  GetNameAndVersions = (contentTypeId) => BaseService.get({ url: `${this.baseUrl}/${contentTypeId}/name-and-versions` });
  //Content Type Has Imputation Plugin Config
  hasImputationPluginConfig = (contentTypeId) => BaseService.get({ url: `has-imputation-plugin-config/${contentTypeId}` });

  clearCacheForContentTypeDeletion = (contentTypeId) => BaseService.post({ url: `${this.baseUrl}/clear-cache-for-ct-deletion/${contentTypeId}` });
}

export default new ContentTypeService();
